import {useContext} from 'react';
import {RadioGroupContext} from 'app/components/sharedReactComponents/RadioGroup/RadioGroupContext';

export function useRadioGroup() {
  return useContext(RadioGroupContext);
}
